import { useMutation, useQuery, useQueryClient } from "react-query";
import useUserContext from "../contexts/UserContext";
import useApiHelper from "../services/useApiHelper";

export default function useAllAgencyProperties(include = true) {
  const staleTime = 1000 * 60; //60 seconds
  const queryClient = useQueryClient();
  const {
    user: { agency },
  } = useUserContext();
  const { get } = useApiHelper();

  const properties = useQuery(["allProperties", agency.id], () => get(`/Property/${agency.id}/all?include=${include}`).then((res) => res.data),
    {
      staleTime: staleTime,
    }
  );

  return {
    properties,
  };
}
